module.exports = __webpack_public_path__ + "images/cyber-monday-blog-banner.png";